define(['jquery', 'jquery.transit', 'modernizr', 'container', 'jump', 'module-faq', 'module-single-video', 'preloader'],
    function ($, transit, modernizr, container, jumpFactory, moduleFaq, moduleSingleVideo, preloader) {

        return (function () {

            const name = 'how-to-watch';

            const model = container.getBaseModel(name);
            const view = container.getBaseView(name);
            const jump = jumpFactory.create();
            const pubSub = container.getPublishSubscribe();
            /* model */

            model.publicVars = {};

            model.privateVars = {};

            model.methods = {

            };

            /* view */

            view.publicVars = {};

            view.privateVars = {
                itemsKeys: [],
                items: new Map(),
                canNavigateAction: 0,

                currentLangSelected: null,
                langChangeAnim: false
            };

            view.startup = function () {


                if(view.publicVars.moduleFaqConfig) {
                    view.privateVars.itemsKeys.push('single-video');

                    view.privateVars.items.set('single-video', {
                        init: false,
                        module: moduleSingleVideo,
                        config: view.publicVars.moduleSingleVideoConfig,
                        callbacks: {}
                    });
                }

                if(view.publicVars.moduleFaqConfig) {
                    view.privateVars.itemsKeys.push('faq');

                    view.privateVars.items.set('faq', {
                        init: false,
                        module: moduleFaq,
                        config: view.publicVars.moduleFaqConfig,
                        callbacks: {}
                    });
                }

                if(view.publicVars.operatorsPreloadTab) {
                    preloader.setPreloadBulk('how-to-watch-operators', view.publicVars.operatorsPreloadTab);
                }

                view.methods.handleCurrentScrollPosition();

                if($(view.publicVars.cssId.langSelectorBoxCls).length > 0) {
                    view.privateVars.currentLangSelected = parseInt(container.getData($(view.publicVars.cssId.langSelectorBoxCls + view.publicVars.cssId.isActiveCls)[0], 'id'));
                }

                // moduleMediaCarousel.init(view.publicVars.moduleMediaCarouselConfig);
                // moduleVideoCarousel.init(view.publicVars.moduleVideoCarouselConfig);

            };

            view.bind = function () {
                $(window).scroll(function () {

                    let ticking = false;

                    if (view.privateVars.canNavigateAction === 0) {

                        if (!ticking) {
                            window.requestAnimationFrame(function () {
                                view.methods.handleCurrentScrollPosition();
                                ticking = false;
                            });
                        }
                        ticking = true;
                    }
                });

                $(window).resize(() => {
                    view.methods.handleCurrentScrollPosition();
                });

                $(window).on('orientationchange', () => {
                    view.methods.handleCurrentScrollPosition();
                });

                $(view.publicVars.cssId.langSelectorBoxCls).click(function () {
                    const id = parseInt(container.getData($(this)[0], 'id'));

                    if(view.privateVars.current !== id && !view.privateVars.langChangeAnim) {
                        view.privateVars.langChangeAnim = true;
                        view.methods.langChangeAction(id);
                    }
                });
            };

            view.methods = {

                handleCurrentScrollPosition: () => {

                    const systemCurrentScroll = $(document).scrollTop();

                    for (let [key, value] of view.privateVars.items) {

                        const targetPos = $(view.publicVars.cssId.layout.navigateTargetId + '-' + key).offset();

                        view.methods.handleModuleInit(systemCurrentScroll, key, targetPos);
                    }
                },

                handleModuleInit: (currentScroll, key, targetPos) => {

                    if (view.privateVars.items.get(key).module && view.privateVars.items.get(key).init === false) {
                        const rect = $(view.publicVars.cssId.layout.navigateTargetId + '-' + key)[0].getBoundingClientRect();
                        const scrollPlusWindowHeight = $(window).height() + currentScroll;

                        if ((targetPos.top - 200) < scrollPlusWindowHeight &&
                            (scrollPlusWindowHeight < (targetPos.top + rect.height) || currentScroll < (targetPos.top + rect.height))) {

                            view.methods.fireModuleStart(key);

                        }
                    }

                },

                fireModuleStart: (key) => {
                    if (view.privateVars.items.get(key).module && view.privateVars.items.get(key).init === false) {

                        view.privateVars.items.get(key).init = true;
                        view.privateVars.items.get(key).module.init(
                            view.privateVars.items.get(key).config,
                            view.privateVars.items.get(key).callbacks
                        );
                    }
                },

                langChangeAction: function (id) {
                    $(view.publicVars.cssId.langSelectorBoxCls).removeClass(view.publicVars.cssId.isActiveCls.substr(1));
                    $(view.publicVars.cssId.langSelectorBoxCls + id).addClass(view.publicVars.cssId.isActiveCls.substr(1));

                    const headerHeight = $(view.publicVars.cssId.headerCls).outerHeight();

                    $(view.publicVars.cssId.operatorBoxWrapperId + view.privateVars.currentLangSelected).transit({ opacity: 0}, 300, function () {
                        $(view.publicVars.cssId.operatorBoxWrapperId + view.privateVars.currentLangSelected).css({ display: 'none', opacity: 1});
                        $(view.publicVars.cssId.operatorBoxWrapperId + id).css({ display: 'block', opacity: 0});
                        jump.centerTo(view.publicVars.cssId.operatorBoxWrapperId + id, null, {
                            modifier: - parseInt(headerHeight)
                        });
                        $(view.publicVars.cssId.operatorBoxWrapperId + id).transit({ opacity: 1 }, 300, function () {
                            view.privateVars.langChangeAnim = false;
                            view.privateVars.currentLangSelected = id;
                        });
                    });
                },


            };

            /* custom events */
            // pubSub.subscribe('view/actionShowSortItems', view.methods.actionShowSortItems);
            //pubSub.subscribe('view/actionShowFormThx', view.methods.actionShowFormThx);
            //pubSub.subscribe('view/showThx', view.methods.showThx);


            /* public methods */
            return {
                init: function (options) {
                    model.init(options);
                    view.init(options);
                }
            };


        })();


    });
